import { Stack } from "@volca/ui/components/ui/stack";
import { DocumentChip } from "@/profitability/document-chip";
import type { ProfitabilityReport } from "@/profitability/types";
import { SettingsGroup, SettingsRow } from "./settings-group";

export const AgentSources = ({ report }: { report: ProfitabilityReport }) => (
  <SettingsGroup title="Source files">
    {report.inputs.map((input) => (
      <SettingsRow
        key={input.key}
        label={input.title}
        hint={input.description}
        value={input.reference ? "Reference file" : undefined}
      />
    ))}
    {report.sample_documents.length > 0 && (
      <SettingsRow
        label="Sample files"
        value={
          <Stack direction="row" gap={2} wrap>
            {report.sample_documents.map((document) => (
              <DocumentChip key={document.id} document={document} />
            ))}
          </Stack>
        }
      />
    )}
    {report.inputs.length === 0 && report.sample_documents.length === 0 && (
      <SettingsRow
        label="No source files listed"
        hint="Source files are configured when this agent is built."
      />
    )}
  </SettingsGroup>
);
